var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8078C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9969 9.34877 20.9424 6.80702 19.0677 4.93232C17.193 3.05762 14.6512 2.00306 12 2ZM16.7626 10.2489L11.1211 15.6336C10.9777 15.77 10.7872 15.8462 10.5892 15.8462C10.3913 15.8462 10.2008 15.77 10.0574 15.6336L7.23738 12.9413C7.09005 12.8001 7.00477 12.6063 7.00025 12.4023C6.99573 12.1984 7.07236 12.0009 7.2133 11.8534C7.35424 11.7059 7.54796 11.6204 7.75192 11.6156C7.95588 11.6108 8.1534 11.6872 8.30108 11.828L10.5892 14.0132L15.6989 9.13567C15.8466 8.99491 16.0441 8.91854 16.2481 8.92331C16.452 8.92809 16.6458 9.01362 16.7867 9.16113C16.9276 9.30864 17.0043 9.50606 16.9998 9.71002C16.9952 9.91399 16.91 10.1078 16.7626 10.2489Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkFill);
export default __webpack_public_path__ + "static/media/ok-fill.48549f75.svg";
export { ForwardRef as ReactComponent };